/** Shown at "/" when the visitor isn't signed in: access is by an admin-issued link only. */
import { Link } from "react-router-dom";
import { AuthShell } from "../../components/ui";
import logoRed from "../../assets/brand/logo-borenius-red.svg";

export function NeedAccessPage() {
  return (
    <AuthShell>
      <img src={logoRed} alt="Borenius" className="mb-6 h-6" />
      <p className="t-overline text-brand">Panic at the Closing</p>
      <h1 className="mt-1 font-display text-fluid-xl font-semibold text-ink">An access link is required</h1>
      <p className="mt-2 text-ink-600">
        This training game is available by invitation. Open the access link your administrator shared
        with you to sign in or create an account.
      </p>
      <p className="mt-4 text-sm text-ink-500">
        Administrator?{" "}
        <Link to="/admin" className="text-brand underline-offset-4 hover:underline">
          Sign in here
        </Link>
        .
      </p>
    </AuthShell>
  );
}
